module.exports = __webpack_public_path__ + "img/Flag_of_Serbia.34222477.svg";